import widgetsService from 'live/services/widgets'
import { addNewEditor } from '../common/editorRegister'
import i18n from 'live/services/i18n'
import ImageLog from './ImageLogChart'
import imageLog from './imageLogReducer'
import thumbnail from '../../../assets/img/imagelog.png'
import { Fields } from '../editor'
import AssetSelector from '../editor/fields/AssetSelector'
import ImageLogTypeSelector from '../editor/fields/ImageLogTypeSelector'
import React from 'react'
import Toogle from '../editor/fields/Toggle'
import NumericField from '../editor/fields/NumericField'
import ScaleField from '../../configurations/ScaleField'
import { widgetWrapper } from 'live/widgets/decorators/pure'
import AxesSizeConfig from '../../configurations/AxesSizeConfig'

const type = 'imagelog'

widgetsService.impl(
    type,
    widgetWrapper(ImageLog, imageLog, {
        mapConfigToRender(configs) {
            return {
                widget: configs.widget,
                dashboardTheme: configs.dashboardContext.theme
            }
        },
        sampleTime: 500
    })
)
widgetsService.policies(type, {
    layers: 1,
    allowYAxisConfig: false,
    allowGroupedYAxis: false,
    defaultReducer: 'list(*) every 1000 items => @chain',
    handleOwnMissingData: true
})
widgetsService.queryHandlerKind(type, type)

widgetsService.properties(type, {})
widgetsService.config(type, {
    verticalEnabled: true,
    hideXAxis: false,
    useDefaultMinMax: true,
    span: 'ts 0 to ts 8000',
    numberOfVisibleAxes: 6,
    scaleMin: null,
    colorScaleOption: 0,
    scaleMax: null,
    spanPicker: {
        type: 'depth',
        configs: {
            depth: {}
        }
    }
})

addNewEditor(
    {
        type,
        order: 11,
        label: i18n('ImageLog'),
        description: i18n('Borehole imaging visualizer'),
        thumbnail: thumbnail
    },
    [
        <Fields name={'channels'}>
            <AssetSelector label={'Asset'} editorOnly={true} />
            <ImageLogTypeSelector label={'ImageLog Type'} editorOnly={true} configField={'imageType'}/>
            <Toogle configField={'useDefaultMinMax'} label={i18n('Use default min/max')} />
            <NumericField skipOn={config => config.useDefaultMinMax} configField={'scaleMin'} label={i18n('Min')} />
            <NumericField skipOn={config => config.useDefaultMinMax} configField={'scaleMax'} label={i18n('Max')} />
        </Fields>,
        <Fields>
            <ScaleField configField={'colorScaleOption'} />
            <AxesSizeConfig configField={'numberOfVisibleAxes'} label={i18n('Size of axes area')}/>
        </Fields>
    ]
)
